import { Trans, useTranslation } from 'react-i18next';

export const Presentation = () => {
  const { t } = useTranslation();
  return (
    <section className='w-full max-w-[75rem] mx-auto py-xs lg:pb-xl lg:pt-xxl xl:pt-[7rem] flex flex-col gap-xs md:gap-xl px-mini'>
      <h2 className='ts-heading-xl md:ts-heading-display text-ctx-content-title md:text-base-primary-600 text-center'>
        <Trans
          components={{
            span: <span className='block' />,
          }}
          i18nKey='home.presentation.full-control'
        />
      </h2>

      <div className='flex flex-col md:flex-row gap-xs'>
        <img
          className='w-[19rem] h-[11.812rem] lg:w-[40.375rem] lg:h-[24.5rem] mx-auto md:mx-none'
          src='/png/presentation.png'
          alt={t('home.presentation.full-control')}
        />
        <div className='flex flex-col gap-xxs'>
          <h3 className='ts-subtitle-sm md:ts-subtitle-lg text-ctx-content-base text-center md:text-left'>
            {t('home.presentation.create-events-securely')}
          </h3>

          <ul className='flex flex-col gap-mini list-disc pl-xxs'>
            {[
              t('home.presentation.register-event'),
              t('home.presentation.sell-tickets'),
              t('home.presentation.reports'),
              t('expert-support'),
            ].map((item) => (
              <li className='ts-paragraph-xs md:ts-paragraph-sm text-ctx-content-base' key={item}>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
